import * as ActionTypes from "./actionTypes";

export function loadNotifications(appKey) {
	return { type: ActionTypes.LOAD_NOTIFICATIONS, appKey };
}

export function loadNotificationsSuccess(notifications) {
	return { type: ActionTypes.LOAD_NOTIFICATIONS_SUCCESS, notifications };
}

export function loadNotificationsFail(errorMessage) {
	return { type: ActionTypes.LOAD_NOTIFICATIONS_FAIL, errorMessage };
}

export function selectNotification(notification) {
	return { type: ActionTypes.SELECT_NOTIFICATION, notification };
}

export function selectNotificationSuccess(notification) {
	return { type: ActionTypes.SELECT_NOTIFICATION_SUCCESS, notification };
}

export function resetCurrentNotification() {
	return { type: ActionTypes.RESET_CURRENT_NOTIFICATION };
}

export function selectNotificationFailure(errorMessage) {
	return { type: ActionTypes.SELECT_NOTIFICATION_FAILURE, errorMessage };
}
